var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-tabs"},[_c('ul',{staticClass:"tabs"},[_c('li',{class:{ active: this.$route.name === 'personal-page-posts' }},[_c('router-link',{attrs:{"to":{
          name: 'personal-page-posts',
          params: { userAccount: _vm.userAccount },
        }}},[_vm._v("推文 ")])],1),_c('li',{class:{ active: this.$route.name === 'personal-page-replies' }},[_c('router-link',{attrs:{"to":{
          name: 'personal-page-replies',
          params: { userAccount: _vm.userAccount },
        }}},[_vm._v("回覆 ")])],1),_c('li',{class:{ active: this.$route.name === 'personal-page-liked' }},[_c('router-link',{attrs:{"to":{
          name: 'personal-page-liked',
          params: { userAccount: _vm.userAccount },
        }}},[_vm._v("喜歡的內容 ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }